// extracted by mini-css-extract-plugin
module.exports = {"back-previous":"BackToPreviousView_back-previous__7cQGL"};